module.exports = __webpack_public_path__ + "4c7e8a9e135fd3799da9d2af070d1035.MP3";